import { SelectOptions } from 'components/commonType';
import { FormConfig } from 'components/form/FormConfig';
import { ECSegmentFormData, ECSegmentType, EventType } from 'core/ecSegment/ECSegment';
import { camelCase } from 'lodash';
import { useCallback, useMemo } from 'react';
import { createSelectOptionsFromEnum } from 'utils/SelectOptionsUtils';
import i18n from 'i18n';
import { renderFormikProductSelectField } from '../components/ProductSelectField';
import { useFormikContext } from 'formik';

const eventTypeOptions: SelectOptions[] = createSelectOptionsFromEnum(
  EventType,
  'ecSegment.eventTypes.',
  [EventType.SEARCH],
  camelCase
);

export const useProductSegmentFields = (type: ECSegmentType) => {

  const { values } = useFormikContext<ECSegmentFormData>();

  const renderProductSelectField = useCallback(() => {
    return renderFormikProductSelectField(
      'inclusion',
      values.advertiserId
    );
  }, [values.advertiserId]);

  const fields = useMemo(() => {
    if (type !== ECSegmentType.PRODUCT) {
      return [];
    }
    return new FormConfig.FieldsBuilder()
      .addFormikSelect({
        label: i18n.t<string>('ecSegmentForm.labels.eventType'),
        name: 'eventType',
        options: eventTypeOptions,
        simpleValue: true
      })
      .addFormikCustom({
        name: 'inclusionContainer',
        label: i18n.t<string>('ecSegmentForm.labels.inclusion'),
        render: renderProductSelectField
      })
      .build();
  }, [type, renderProductSelectField]);

  return fields;
};
